/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Данные по категории продукта.
 */
export interface CategoryView { 
    /**
     * ID категории.
     */
    id: string;
    /**
     * Наименование категории.
     */
    name?: string;
    /**
     * ID группы категории.
     */
    categoryGroupId?: string;
    /**
     * Наименование группы категории.
     */
    categoryGroupName?: string;
}

